module.exports = __webpack_public_path__ + "static/media/expectancyvalue.06afa2fa.jpeg";